// extracted by mini-css-extract-plugin
module.exports = {"stepThreeContainer":"style_stepThreeContainer__3Xefm","imgThree":"style_imgThree__o0t9R","tips":"style_tips__2Dobs","btns":"style_btns__3ouH3"};